<nav class="sidebar-create-nav" [class.collapsed]="!expanded">
  <div class="sidebar-create-logo">
    @if(!expanded){
      <img src="./../../assets/kaizen-pen-logo.png" alt="Logo" class="lobo-sidebar" />
    } @else {
      <img src="./../../assets/logo.png" alt="Logo" />
    }
  </div>

  <ul class="sidebar-create-menu">
    @for(item of menus; track item.labelKey) {
      @if(item.show && (!item.adminOnly || isAdminUser)) {
        @if(item.children?.length) {
          @for(child of item.children; track child.url) {
            <li>
              <a
                [routerLink]="child.url"
                class="sidebar-create-menu-item"
                [class.active]="isChildRouteActive(child.url)"
                (click)="onSignRequestChildClick($event, child.url); onMenuItemClick()"
                [matTooltip]="expanded ? '' : (child.labelKey | translate)">
                @if(child.imgIcon) {
                  @if(child.imgIconActive) {
                    <span class="sidebar-menu-icon" aria-hidden="true">
                      <img [src]="child.imgIcon" alt="" class="sidebar-menu-img-icon sidebar-menu-img-icon--default" />
                      <img [src]="child.imgIconActive" alt="" class="sidebar-menu-img-icon sidebar-menu-img-icon--active" />
                    </span>
                  } @else {
                    <img [src]="child.imgIcon" alt="" class="sidebar-menu-img-icon" />
                  }
                } @else {
                  <mat-icon>{{ childMenuIcon(child.url) }}</mat-icon>
                }
                @if(expanded) {
                  <span>{{ child.labelKey | translate }}</span>
                }
              </a>
            </li>
          }
        } @else {
          <li>
            <a
              [routerLink]="item.url!"
              class="sidebar-create-menu-item"
              [class.active]="isLeafMenuActive(item)"
              (click)="onMenuItemClick()"
              [matTooltip]="expanded ? '' : (item.labelKey | translate)">
              @if(item.imgIcon) {
                @if(item.imgIconActive) {
                  <span class="sidebar-menu-icon" aria-hidden="true">
                    <img [src]="item.imgIcon" alt="" class="sidebar-menu-img-icon sidebar-menu-img-icon--default" />
                    <img [src]="item.imgIconActive" alt="" class="sidebar-menu-img-icon sidebar-menu-img-icon--active" />
                  </span>
                } @else {
                  <img [src]="item.imgIcon" alt="" class="sidebar-menu-img-icon" />
                }
              } @else {
                <mat-icon>{{ item.icon }}</mat-icon>
              }
              @if(expanded) {
                <span>{{ item.labelKey | translate }}</span>
              }
            </a>
          </li>
        }
      }
    }
  </ul>

</nav>
